module.exports = __webpack_public_path__ + "img/239.4793c2d7.jpg";